module.exports = __webpack_public_path__ + "static/media/ban-khar-ability.eb656b15.svg";